<template>
  <button
    type="button"
    role="switch"
    :class="['sk-switch', { 'is-on': modelValue, disabled }]"
    :disabled="disabled"
    @click.stop.prevent="onToggle"
   data-testid="components-ui-sk-switch-sk-switch-button">
    <span class="sk-switch__track" data-testid="components-ui-sk-switch-sk-switch-span">
      <span
        class="sk-switch__knob"
        :style="knobStyle"
       data-testid="components-ui-sk-switch-sk-switch-span-2"></span>
    </span>
  </button>
</template>

<script setup>
import { computed } from 'vue'

const emits = defineEmits(['update:modelValue', 'change'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  color: {
    type: String,
    default: '#3A7CCA'
  }
})

const toggle = computed({
  get: () => props.modelValue,
  set(v) {
    emits('update:modelValue', v)
    emits('change', v)
  }
})

const knobTranslateX = computed(() => {
  const dx = props.modelValue ? 11 : 0
  return `${dx}px`
})

const knobStyle = computed(() => ({
  transform: `translateX(${knobTranslateX.value})`
}))

function onToggle() {
  if (props.disabled) return

  toggle.value = !toggle.value
}
</script>

<style lang="scss" scoped>
.sk-switch {
  width: 27px;
  height: 16px;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &__track {
    box-sizing: content-box;
    width: 23px;
    height: 12px;
    padding: 2px;
    border-radius: 999px;
    background: #859cb9;
    transition:
      background-color 160ms linear,
      box-shadow 120ms linear;
    display: inline-block;
    position: relative;
  }

  &__knob {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
    transition:
      transform 160ms cubic-bezier(0.2, 0.9, 0.3, 1),
      left 160ms linear;
  }
}
.sk-switch.disabled,
.sk-switch:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.sk-switch.is-on .sk-switch__track {
  background: v-bind(color);
}
</style>
